/* tslint:disable:max-classes-per-file */
import PjnException from './PjnException';
import { ErrorDTO } from './ErrorDTO';
import { ValidationErrorDTO } from './ValidationErrorDTO';
/**
 * Excepcion que ocurre cuando hay un problema de conexion con el server.
 *
 * @export
 * @class ConnectionException
 * @extends {PjnException}
 */
export class ConnectionException extends PjnException {
    constructor(error) {
        super('Error de conexión con el servidor');
        if (error)
            this.name = error.name;
    }
}
/**
 * Excepcion base (abstracta) para errores que se reciben del server en formato {ErrorDTO}
 *
 * @export
 * @abstract
 * @class RemoteException
 * @extends {PjnException}
 */
export class RemoteException extends PjnException {
    constructor(error) {
        super(error.message);
        this.code = error.code;
    }
}
/**
 * Excepcion que indica que el request no fue valido (por ej error de validacion)
 *
 * @export
 * @class InvalidRequestException
 * @extends {RemoteException}
 */
export class InvalidRequestException extends RemoteException {
}
/**
 * Excepcion que se recibe cuando el request fue invalido por algunos campos erroneos.
 *
 * @export
 * @class FieldValidationException
 * @extends {InvalidRequestException}
 */
export class FieldValidationException extends InvalidRequestException {
    constructor(error) {
        super(error);
        this.fields = error.fields;
    }
}
/**
 * Excepcion que indica que la entidad deseada no fue encontrada.
 *
 * @export
 * @class EntityNotFoundException
 * @extends {RemoteException}
 */
export class EntityNotFoundException extends RemoteException {
}
/**
 * Excepcion que indica que la URL pedida no existe (recurso no encontrado)
 *
 * @export
 * @class URLNotFoundException
 * @extends {RemoteException}
 */
export class URLNotFoundException extends RemoteException {
    constructor(error) {
        if (error.code === 'error_rest') {
            error.message = 'No se encontró el recurso';
            error.code = 'recurso_no_existente';
        }
        super(error);
        this.code = error.code;
    }
}
/**
 * Excepcion que se recibe del server cuando hay un conflicto de negocio
 * (por ej querer crear una entidad que ya existe)
 *
 * @export
 * @class ConflictException
 * @extends {RemoteException}
 */
export class ConflictException extends RemoteException {
}
/**
 * Excepcion que se recibe cuando hubo un problema en el servidor al procesar el request
 *
 * @export
 * @class ServerException
 * @extends {RemoteException}
 */
export class ServerException extends RemoteException {
}
/**
 * Excepcion base de seguridad
 *
 * @export
 * @abstract
 * @class SecurityException
 * @extends {RemoteException}
 */
export class SecurityException extends RemoteException {
}
/**
 * Excepcion que se recibe cuando hubo un problema en la autenticacion
 * (usuario no autenticado, credenciales erroneas, sesion terminada, etc)
 *
 * @export
 * @class AuthenticationException
 * @extends {SecurityException}
 */
export class AuthenticationException extends SecurityException {
}
/**
 * Excepcion que se recibe cuando hubo un error de autorizacion (el usuario esta autenticado pero no
 * tiene permisos para acceder a un recurso o realizar una operacion).
 *
 * @export
 * @class AuthorizationException
 * @extends {SecurityException}
 */
export class AuthorizationException extends SecurityException {
}
/**
 * Excepcion generico de servidor cuando no se pudo identificar que fue lo que fallo.
 *
 * @export
 * @class GenericServerException
 * @extends {ServerException}
 */
export class GenericServerException extends ServerException {
    constructor() {
        super(new ErrorDTO('server_error', 'Hubo un error inesperado en el servidor'));
    }
}
/**
 * Crea una excepcion remota a partir del status code y el payload (que deberia ser {ErrorDTO}).
 *
 * @export
 * @param {number} status codigo de status del responde
 * @param {*} payload payload del response
 * @returns {PjnException}
 */
export function createRemoteException(status, payload) {
    const error = buildErrorDTO(payload);
    if (!error) {
        console.error('El server devolvio status de error pero no un ErrorDTO, se lanza un ServerError');
        throw new GenericServerException();
    }
    switch (status) {
        case 400:
            if (error instanceof ValidationErrorDTO)
                return new FieldValidationException(error);
            return new InvalidRequestException(error);
        case 401:
            return new AuthenticationException(error);
        case 403:
            return new AuthorizationException(error);
        case 404:
            if (error.code === 'entidad_no_existente')
                return new EntityNotFoundException(error);
            return new URLNotFoundException(error);
        case 409: return new ConflictException(error);
        default: return new ServerException(error);
    }
}
function buildErrorDTO(payload) {
    if (!payload.code || !payload.message)
        return undefined;
    if (payload.fields)
        return new ValidationErrorDTO(payload.code, payload.message, payload.fields);
    return new ErrorDTO(payload.code, payload.message);
}
//# sourceMappingURL=server.js.map